import { useSidePanelSlot } from "components/AppLayout/SidePanelSlotContext";
import { ReactNode } from "react";
import { createPortal } from "react-dom";

type AppSidePanelProps = {
  children: ReactNode;
};

export const AppSidePanel = ({ children }: AppSidePanelProps) => {
  const { slot } = useSidePanelSlot();

  if (!slot) {
    return null;
  }

  return createPortal(children, slot);
};
